import React from "react";

import "swiper/css";
import "swiper/css/pagination";

import "../assets/css/carousel.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import {ReactComponent as Facebook } from "../assets/icons/Facebook.svg";
import {ReactComponent as Instagram} from "../assets/icons/Instagram.svg";
import { ReactComponent as WhatsApp } from "../assets/icons/Whatsapp.svg";
import { ReactComponent as TikTok } from "../assets/icons/Tiktok.svg";
import { ReactComponent as Linkedin } from "../assets/icons/Linkedin.svg";

import fondo1 from "../assets/img/fondo 1.png";
import fondo2 from "../assets/img/fondo 2.png";
import fondo3 from "../assets/img/fondo 3.png";
import title from "../assets/svg/logo-inicio.svg";

const slides = [
  {
    id: 1,
    background: fondo1,
    content: (
      <div className="img-content">
        <img src={title} alt="Título principal" />
      </div>
    ),
  },
  {
    id: 2,
    background: fondo2,
    content: (
      <div className="text-content1">
        <p>Torres & Torres</p>
        <h1>Tu Firma Legal de Confianza</h1>
        <h1>
          en el <span className="color-text">Perú</span>
        </h1>
        <div className="button-group">
          <button className="boton1">Contáctanos Ahora!</button>
          <button className="boton2">Conoce Nuestros Servicios</button>
        </div>
      </div>
    ),
  },
  {
    id: 3,
    background: fondo3,
    content: (
      <div className="text-content2">
        <p>Compromiso y Excelencia en Cada Caso</p>
        <h1>
          En <span className="color-text">Torres & Torres</span>, trabajamos
          contigo para ofrecer
        </h1>
        <h1>soluciones, garantizando confianza y resultados.</h1>
        <div className="button-group">
          <button className="boton2">Conoce Nuestros Valores</button>
          <button className="boton1">Descubre Más</button>
        </div>
      </div>
    ),
  },
];

const Carousel = () => {
  return (
    <div className="carousel-wrapper">
      <Swiper
        modules={[Autoplay, Pagination]}
        spaceBetween={0}
        slidesPerView={1}
        loop={true}
        autoplay={{ delay: 6000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        className="carrusel-container">
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div className="slide-content">
              <img
                src={slide.background}
                alt={`Fondo ${slide.id}`}
                className="background-img"
              />
              {slide.content}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="pagination-container">
        <div className="social-icons">
          <a
            href="https://www.instagram.com/estudiostte/"
            target="_blank"
            rel="noopener noreferrer">
            <Instagram />
          </a>
          <a
            href="https://www.facebook.com/TyTasesores"
            target="_blank"
            rel="noopener noreferrer">
            <Facebook />
          </a>
          <a
            href="https://wa.me/51988070758"
            target="_blank"
            rel="noopener noreferrer">
            <WhatsApp />
          </a>
          <a
            href="https://www.tiktok.com/@estudiotyt"
            target="_blank"
            rel="noopener noreferrer">
            <TikTok />
          </a>
          <a
            href="https://www.linkedin.com/in/torres-y-torres-29bb39349/"
            target="_blank"
            rel="noopener noreferrer">
            <Linkedin />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Carousel;
